import * as React from 'react';
import styled from 'styled-components';
import ActionButton from '@westwing/ui-kit/ActionButton';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import useQuestionnaireFlow from '@ids/hooks/useQuestionnaireFlow';

export const StyledCTAButton = styled(ActionButton)`
    && {
        cursor: pointer;
        background: ${({ theme }) => theme.colors.charcoal100};
        border-color: ${({ theme }) => theme.colors.charcoal100};

        ${forTablet`
            width: min(335px, 100%);
            height: 44px;
            line-height: initial;
        `}

        &:hover:not(:disabled) {
            background: ${({ theme }) => theme.colors.charcoal80};
            border-color: ${({ theme }) => theme.colors.charcoal80};
        }
    }
`;

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode;
}

const CTAButton = ({ children, onClick, ...buttonProps }: ButtonProps) => {
    const { startQuestionnaire } = useQuestionnaireFlow();

    const handleCTAButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (onClick) {
            onClick(event);
        }
        startQuestionnaire();
    };

    return (
        <StyledCTAButton kind="primary" onClick={handleCTAButtonClick} {...buttonProps}>
            {children}
        </StyledCTAButton>
    );
};

export default CTAButton;
